module.exports = __webpack_public_path__ + "static/media/logo_big.26a178e7.svg";